import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

/**
 * True when the primary input is a finger — phones and tablets, i.e. devices with a camera
 * worth offering. why: `pointer: coarse` instead of user-agent sniffing; a touchscreen laptop
 * still reports a fine primary pointer and counts as desktop.
 */
export function useIsTouchDevice(): boolean {
  const [touch, setTouch] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(QUERY);
    const onChange = () => setTouch(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return touch;
}
